import React from "react";
import styles from "./FooterPopUp.module.css";
import { pushToGA } from "../../Services/users";
import { connect } from "react-redux";

interface FooterPopUpProps {
  setModal: (open: boolean) => void;
  children: React.ReactNode;
  modiferClass?: string; 
  closeIcon: boolean;
  closeClassMofifier?:any;
  popupName?:string;
  user?: any,
  closeIconClass?: string; 
}

const FooterPopUp: React.FC<FooterPopUpProps> = ({
  setModal,
  children,
  modiferClass = "",
  closeIcon,
  closeClassMofifier,
  closeIconClass,
}) => {
  const closeModal = () => {
    setModal(false);
    document.body.classList.remove("no-overflow");
  };

  return (
    <>
      <div className={styles.FooterPopUp}>
        <div className={`${styles.FooterPopUpContent} ${modiferClass}`}>
          {closeIcon && <div className={`${styles.FooterPopUpClose} ${closeClassMofifier}`} onClick={closeModal}></div>}
          {/* {closeIcon && <div className={`${styles.FooterPopUpClose} ${closeIconClass}`} onClick={closeModal}></div>} */}
          {children}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(FooterPopUp);